$(function(){
    
    $(".testimonial-slider").slick({
        // options...
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1,

            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '0px',
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '0px',
                        slidesToShow: 1
                    }
                }
            ]
        // dotsClass: 'carousel-indicators',
        /*customPaging: function(slider, i) {
            return $('');
        }*/
        });
    // $('.slickSlider').slick('slickSetOption', 'fade', false, true);




        // check if any sections have has-list class
        // console.log( $(this).hasClass('has-list') ) ;
        $( "section.has-list" ).find( "ul" ).addClass('square-list');

        // bootstrap menu dropdown remv me-3 class
        $('.dropdown-menu').find('.nav-item').removeClass('me-3');

        // removeDataAttribute();

        $("#searchTerm").keypress(function (e) {
            var key = e.which;
            // the enter key code
            if (key == 13) {
                search($("#searchTerm").val());
                return false;
            }
        });

        $("#search-keyword").keypress(function (e) {
            var key = e.which;
            // the enter key code
            if (key == 13) {
                search($("#search-keyword").val());
                return false;
            }
        });

        $('#openSearch').click(function(e){
            $('#searchbox').removeClass('d-none');
            $('#searchbox').addClass('d-flex');
        });

        //$('.dropdown .nav-link').on('click', function(e){
            
            //if( $('#navbarSupportedContent').hasClass('show') ){
                // e.preventDefault();
                // e.stopPropagation();
                
                /*$('.dropdown .dropdown-menu').each(function(){
                    // $(this).removeClass('show');
                });*/
                // get all dropdown-menu classes and remove show class
                // $(this).parent().siblings().removeClass('show');
                // find next class dropdown-menu
                //$(this).parent().toggleClass('active');
                //var g = $(this).next();
                //g.toggleClass('show');
                

                
            //}
            
        // });

        $("#navbarSupportedContent .nav-link").click((e)=>{
            
            $(this).addClass("active");
        });


         

        function search(value) {
            var searchPageURL = "/search/results";
            var searchIndex = "Culinex";
            if (searchIndex && value) {
                window.location = searchPageURL + '?indexCatalogue=' + searchIndex + '&q=' + value + '&wordsMode=0';
            }
        }

        if( $('#subscribeForm').prev().hasClass('fui-alert') ){
            console.log('alert created');
        }   
        
        /*$('#fui-subscribeForm-zahnjw').on('submit', function(e){ 
            e.preventDefault();
            console.log('form has been submitted');
        });*/
        
    
});